function updatePendoGuides(disabled: boolean): void {
  if (typeof window.pendo === "undefined" || !window.pendo) return;

  setTimeout(() => {
    try {
      window.pendo.setGuidesDisabled(disabled);
      if (disabled) {
        window.pendo.stopGuides?.();
      } else {
        window.pendo.loadGuides?.();
      }
    } catch (e) {
      console.error(
        `[Pendo] Error ${disabled ? "disabling" : "enabling"} guides:`,
        e,
      );
    }
  }, 1000);
}

export function enablePendoGuides(): void {
  updatePendoGuides(false);
}

export function disablePendoGuides(): void {
  updatePendoGuides(true);
}
